import tlds from "tlds";

export type DetectedURL = {
  url: string;
  markdownFormatted: boolean;
  protocol: boolean;
  file: boolean;
};

const URL_REGEXP = new RegExp(
  `(?<markdownFormatted>\\[.*?\\]\\()?(?<url>(?<protocol>https?://)?(?:www\\.)?[\\p{L}\\p{N}\\.-]+\\.(?:${tlds.join("|")})(?:[^\\s]*[^\\s\\.,>\\)\\\\])?)`,
  "giu",
);

const FILE_REGEXP =
  /\.(jpe?g|png|gif|webp|bmp|svg|tiff|ico|avif|apng|pdf|docx?|xlsx?|pptx?|zip|rar|7z|tar|gz|bz2|xz|mp4|webm|ogg|mp3|wav|flac|aac|wma|opus|flv|avi|mov|wmv|mkv|ts|mpg|mpeg|vob|webp|pdf|docx?|xlsx?|pptx?|zip|rar|7z|tar|gz|bz2|xz|mp4|webm|ogg|mp3|wav|flac|aac|wma|opus|flv|avi|mov|wmv|mkv|ts|mpg|mpeg|vob|webp)$/i;

export const detectUrls = (content: string) => {
  // Replace escaped Markdown characters like \: \_ \.
  content = content.replaceAll(/\\([:_.])/g, "$1").trim();

  const urls: DetectedURL[] = [];
  let match;
  while ((match = URL_REGEXP.exec(content)) !== null) {
    const { markdownFormatted, protocol, url } = match.groups || {};
    urls.push({
      url,
      markdownFormatted: !!markdownFormatted,
      protocol: !!protocol,
      file: FILE_REGEXP.test(url.split("?")[0]),
    });
  }
  URL_REGEXP.lastIndex = 0;
  return urls;
};
